import { ContextMenu, ContextEnumItemGroup, ContextEnumItem } from '../../BaseShape/ContextMenu';

export class ExternalServiceContextMenu extends ContextMenu {
  constructor(cell?: any, evtTarget?: any, data?: any) {
    super();
    const content = new Array<ContextEnumItemGroup>();
    const baseGroup = new ContextEnumItemGroup();
    baseGroup.addItem(new ContextEnumItem('新增：参数', 'shape:addESParameter', true));
    content.push(baseGroup);
    this.set('hasEditGroup', true);
    if (evtTarget?.attributes.index) {
      const index = parseInt(evtTarget.attributes.index.value);
      const isLast = evtTarget.attributes.isLast.value === 'true';
      this.set('hasMoveGroup', true);
      this.set('rowIndex', index);
      this.set('isLastRow', isLast);
    }

    this.set('content', content);
  }
}
